import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';
import { useNavigate } from 'react-router-dom';

function CustomColumnMenu(props) {
  return (
    
    <GridColumnMenu
      {...props}
      slots={{
     // Hide `columnMenuColumnsItem`
      columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    
);
}
const columns = [

  { field: 'No', headerName: 'No', editable: false, sortable: false, minWidth: 100 }, 
  { field: 'Date', headerName: 'Date', editable: false, sortable: false, minWidth: 100}, 
  { field: 'Job_Type', headerName: 'Job Type', editable: false, sortable: false, flex: 1, minWidth: 100 }, 
  { field: 'Count', headerName: 'Count', editable: false, sortable: false, minWidth: 100}, 
  { field: 'Amount', headerName: 'Amount', editable: false, sortable: false, minWidth: 100}, 
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 110, 
    renderCell: (params) => { 
      return ( 
        <ActionButtons title='Convert To Estimate' status={params.row.enstatus==='Enquiry'?true:false} page='add_estimate'/>
      );
     } 
  } 
  ];
   
  const rows = [
  
  { No: 1231, Date: '05-02-2023', Job_Type:'Punchar Repair', Count:4, Amount:250 }, 
  { No: 1232, Date: '12-02-2023', Job_Type:'Wheel Aligment', Count:2, Amount:750 },
  { No: 1233, Date: '21-02-2023', Job_Type:'Tyres', Count:4, Amount:2000},  
  { No: 1234, Date: '25-02-2023', Job_Type:'General Repair', Count:3, Amount:2250 }, 
  { No: 1235, Date: '29-02-2023', Job_Type:'Punchar Repair', Count:2, Amount:250 },
  ];
  
function CashJob() {
  const navigate = useNavigate()
return (
  <Box mt={2}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
              CASH JOB
            </Typography>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Button sx={buttonStyle.root} onClick={() => navigate("/Add_Cash_Job")}>
              <AddIcon />
              Add Cash Job
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} mt={1}>
        <Box sx={dataGridStyle.root}>
        <DataGrid
          columnHeaderHeight={42}
          rowHeight={40}
          rows={rows}
          columns={columns}
          getRowId={(row) => row.No}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10]}
          slots={{ columnMenu: CustomColumnMenu }}
          disableRowSelectionOnClick
        />
      </Box>
      </Grid>
    </Grid>
  </Box>
);
}
export default CashJob